/* eslint-disable */
import React, {Component} from 'react';
import Form from "react-bootstrap/Form";
import {Button, Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Select, {components, DropdownIndicatorProps} from "react-select";
import del from "../../assets/icons/del.png";
import edit from "../../assets/icons/edit.png";
import add from "../../assets/icons/add.png";
import arrow_up from "../../assets/icons/dark_arrow_up.png";
import arrow_down from "../../assets/icons/dark_arrow_down.png";
import {Typography} from "@material-ui/core";

export class OrganicTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fertilizers: [],
            columns: [],
            save: -1,
            isModalShow: false,
            patterns: [],
            update: false,
            selectedPattern: '',
            patterns_list: [],
            isAdd: true,
            rowId: "",
            afterChange: false,
            row_save: {
                "id": 0,
                "name": "",
                "consuming1": {"n": 0, "p2O5": 0, "k2O": 0, "s": 0, "caO": 0, "mg": 0},
                "consuming2": {"n": 0, "p2O5": 0, "k2O": 0, "s": 0, "caO": 0, "mg": 0},
                "price": '0',
                'userId': '',
            }
        };
        this.AddModal = this.AddModal.bind(this)
        this.checkRowStorage = this.checkRowStorage.bind(this)
        this.checkRowCalc = this.checkRowCalc.bind(this)
        this.handleChangeSelectFertilizer = this.handleChangeSelectFertilizer.bind(this)
        this.handleClickDelete = this.handleClickDelete.bind(this)
    }

    componentDidMount() {
        this.populateFertilizersData();
    }

    handleClickDelete(rowId) {
        fetch('api/fertilizerOrganic?id=' + rowId, {
            method: 'DELETE',
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        }).then((response) => {
            if (response.ok) {
                response.json().then((result)=>{
                    if(result.info === 'use'){
                        this.props.setModal(false, 'Удобрение используется в расчетах и не может быть удалено')
                    }else{
                        this.state.fertilizers.splice(this.state.fertilizers.findIndex((r) => r.id === rowId), 1)
                        this.props.setModal(true, 'Удобрение успешно удалено')
                        this.forceUpdate()
                    }
                })
            }else {
                this.props.setModal(false, 'Ошибка удаления удборения')
            }
        })
    }

    saveResponse = () => {
        this.setState({save: 0})
        fetch('api/fertilizerOrganic', {
            method: 'POST',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.row_save)
        }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    this.setState({fertilizers: this.state.fertilizers.concat(result)})
                    this.setState({save: 2, isModalShow: false, afterChange: false}, () => {
                        this.forceUpdate()
                    })
                });
            } else {
                this.setState({save: 1})
            }
        });
    }

    changeResponse = () => {
        this.setState({save: 0})
        fetch('api/fertilizerOrganic', {
            method: 'PUT',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.row_save)
        }).then((response) => {
                if (response.ok) {
                    response.json().then((result) => {
                        this.state.fertilizers.splice(this.state.fertilizers.findIndex((r) => r.id === result.id), 1, result)
                        this.setState({save: 2, isModalShow: false, afterChange: true})
                    })
                } else {
                    this.setState({save: 1, isModalShow: false})
                }
            }
        )
        ;
    }

    handleChangeSelectFertilizer(e) {
        const fertilizer = this.state.patterns.find((f) => f.id === e.value)
        this.state.row_save.name = fertilizer.name
        this.state.row_save.consuming1 = fertilizer.consuming1
        this.state.row_save.consuming2 = fertilizer.consuming2
        this.state.row_save.price = fertilizer.price
        this.state.row_save.id = 1
        this.setState({selectedPattern: e.value})
    }

    checkRowStorage(row) {
        this.state.data.find((r) => r.id === row.id).inStorage = !row.inStorage
    }

    checkRowCalc(row) {
        this.state.data.find((r) => r.id === row.id).inUse = !row.inUse
    }

    AddModal(props, isAdd, rowId, afterChange) {
        if (this.state.patterns.length !== 0) {
            if (isAdd) {
                if (this.state.row_save.id === 0 || afterChange) {
                    const fertilizer = this.state.patterns[0]
                    this.state.row_save.name = fertilizer.name
                    this.state.row_save.consuming1 = fertilizer.consuming1
                    this.state.row_save.consuming2 = fertilizer.consuming2
                    this.state.row_save.id = 0
                }
            } else {
                const fertilizer = this.state.fertilizers.find((row) => row.id === rowId)
                if (fertilizer) {
                    this.state.row_save.id = fertilizer.id
                    this.state.row_save.name = fertilizer.name
                    this.state.row_save.consuming1 = fertilizer.consuming1
                    this.state.row_save.consuming2 = fertilizer.consuming2
                    this.state.row_save.price = fertilizer.price
                } else {
                    const fertilizer = this.state.patterns[0]
                    this.state.row_save.name = fertilizer.name
                    this.state.row_save.consuming1 = fertilizer.consuming1
                    this.state.row_save.consuming2 = fertilizer.consuming2
                    this.state.row_save.id = 0
                }

            }
        }
        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет полей</Typography>;
        }

        let selected_fertilizer = this.state.patterns.length !== 0 ? isAdd ?
            this.state.patterns.find((f) => f.id === this.state.selectedPattern)
            : this.state.fertilizers.find((row) => row.id === rowId) : {consuming1: {}, consuming2: {}}
        if (!selected_fertilizer)
            selected_fertilizer = {consuming1: {}, consuming2: {}}
        return (
            <Modal show={props}
                   backdrop="static"
                   keyboard={false}
                   onHide={() => this.setState({isModalShow: false, afterChange: !isAdd})}
                   centered
                   size="lg"
                   id="modal-add">
                <Modal.Header closeButton>
                    <Modal.Title>{isAdd ? "Добавить органическое удобрение" : "Редактировать удобрение"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <Form onSubmit={this.handleSubmit}>
                            <div className="row type-select-row">
                                <div className="col" style={{width: "200px"}}>
                                    <Form.Group>
                                        <Form.Label>Шаблон удобрения</Form.Label>
                                        <Select
                                            className='field-select'
                                            maxMenuHeight='230px'
                                            placeholder='Выберите удобрение'
                                            components={{DropdownIndicator, NoOptionsMessage}}
                                            theme={(theme) => ({
                                                ...theme,
                                                border: '1px solid #ABB3D1',
                                                borderRadius: '10px',
                                                colors: {
                                                    ...theme.colors,
                                                    primary: '#ABB3D1',
                                                },
                                            })}
                                            styles={{
                                                container: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    width: '455px',
                                                    height: '52px',
                                                }),
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                                    height: '52px',
                                                    width: '455px',
                                                }),
                                                menu: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    border: ' 1px solid #ABB3D1',
                                                    borderRadius: '10px',
                                                    margin: '0'
                                                }),
                                                input: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    height: '45px',
                                                }),
                                                option: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    color: '#201E44',
                                                    height: '45px',
                                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                                }),
                                                menuList: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    paddingRight: '13px !important',
                                                    "::-webkit-scrollbar": {
                                                        width: '3px !important'
                                                    },
                                                    "::-webkit-scrollbar-track": {
                                                        background: '#E2E4EF !important',
                                                        borderRadius: '6px !important'
                                                    },
                                                    "::-webkit-scrollbar-thumb": {
                                                        background: ' #ABB3D1 !important',
                                                        borderRadius: '6px !important'
                                                    },
                                                    "::-webkit-scrollbar-thumb:hover": {
                                                        background: ' #ABB3D1 !important',
                                                    }
                                                })
                                            }}
                                            id="fertilizer-type-select"
                                            defaultValue={this.state.patterns_list.length !== 0 ?
                                                this.state.patterns_list.find((f) => f.label === selected_fertilizer.name)
                                                : ""}
                                            options={this.state.patterns_list}
                                            onChange={(e) => this.handleChangeSelectFertilizer(e)}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <Form.Group>
                                        <Form.Label>Наименование</Form.Label>
                                        <Form.Control
                                            defaultValue={selected_fertilizer.name}
                                            onChange={(e) => this.state.row_save.name = e.target.value}
                                            key={this.state.selectedPattern}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col">
                                    <Form.Group style={{maxWidth: '150px'}}>
                                        <Form.Label>Цена, руб/т</Form.Label>
                                        <Form.Control type="Number"
                                                      min={0}
                                                      key={this.state.selectedPattern}
                                                      defaultValue={selected_fertilizer.price}
                                                      onChange={(e) => this.state.row_save.price = e.target.value}/>
                                    </Form.Group>
                                </div>
                            </div>
                            <div className="row elements-add-row">
                                <Form.Label>Потребление растениями элементов питания, кг/т </Form.Label>
                                <table border className='form-organic-table'>
                                    <thead>
                                    <tr>
                                        <th>Год 1</th>
                                        <th>Год 2</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>
                                            <div className="row">
                                                <div className="col">
                                                    <Form.Group>
                                                        <Form.Label><i>N</i></Form.Label>
                                                        <Form.Control type="number" min={0}
                                                                      defaultValue={selected_fertilizer.consuming1.n}
                                                                      onChange={(e) => this.state.row_save.consuming1.n = e.target.value}
                                                                      key={this.state.selectedPattern}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col">
                                                    <Form.Group>
                                                        <Form.Label><i>P<sub>2</sub>O<sub>5</sub></i></Form.Label>
                                                        <Form.Control type="Number" min={0}
                                                                      defaultValue={selected_fertilizer.consuming1.p2O5}
                                                                      key={this.state.selectedPattern}
                                                                      onChange={(e) => this.state.row_save.consuming1.p2O5 = e.target.value}/>
                                                    </Form.Group>
                                                </div>
                                                <div className="col">
                                                    <Form.Group>
                                                        <Form.Label><i>K<sub>2</sub>O</i></Form.Label>
                                                        <Form.Control type="Number" min={0}
                                                                      defaultValue={selected_fertilizer.consuming1.k2O}
                                                                      key={this.state.selectedPattern}
                                                                      onChange={(e) => this.state.row_save.consuming1.k2O = e.target.value}/>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="row">
                                                <div className="col">
                                                    <Form.Group>
                                                        <Form.Label><i>N</i></Form.Label>
                                                        <Form.Control type="number" min={0}
                                                                      defaultValue={selected_fertilizer.consuming2.n}
                                                                      onChange={(e) => this.state.row_save.consuming2.n = e.target.value}
                                                                      key={this.state.selectedPattern}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col">
                                                    <Form.Group>
                                                        <Form.Label><i>P<sub>2</sub>O<sub>5</sub></i></Form.Label>
                                                        <Form.Control type="Number" min={0}
                                                                      defaultValue={selected_fertilizer.consuming2.p2O5}
                                                                      key={this.state.selectedPattern}
                                                                      onChange={(e) => this.state.row_save.consuming2.p2O5 = e.target.value}/>
                                                    </Form.Group>
                                                </div>
                                                <div className="col">
                                                    <Form.Group>
                                                        <Form.Label><i>K<sub>2</sub>O</i></Form.Label>
                                                        <Form.Control type="Number" min={0}
                                                                      defaultValue={selected_fertilizer.consuming2.k2O}
                                                                      key={this.state.selectedPattern}
                                                                      onChange={(e) => this.state.row_save.consuming2.k2O = e.target.value}/>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='save-btn' onClick={isAdd ? this.saveResponse : this.changeResponse}>
                        {isAdd ? "Добавить" : "Сохранить"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Загрузка...</em></p>
            :
            <div>
                <table className="fertilizer-table">
                    <thead className="align-middle">
                    <tr>
                        <th width="27%" rowSpan={3}>Наименование</th>
                        <th width="66%" colSpan={6}>Потребление растениями элементов питания из органических удобрений,
                            кг/т
                        </th>
                        <th width="7%" rowSpan={3}>Цена,<br/>руб/т</th>
                    </tr>
                    <tr>
                        <th width="33%" colSpan={3}>Год 1</th>
                        <th width="33%" colSpan={3}>Год 2</th>
                    </tr>
                    <tr>
                        <th width="11%"><i>N</i></th>
                        <th width="11%"><i>P<sub>2</sub>O<sub>5</sub></i></th>
                        <th width="11%"><i>K<sub>2</sub>O</i></th>
                        <th width="11%"><i>N</i></th>
                        <th width="11%"><i>P<sub>2</sub>O<sub>5</sub></i></th>
                        <th width="11%"><i>K<sub>2</sub>O</i></th>
                    </tr>
                    </thead>
                </table>
                <DataTable
                    data={this.state.fertilizers}
                    columns={this.state.columns}
                    responsive={false}
                    noTableHead={true}
                    key={this.state.update}
                    noDataComponent=''
                    customStyles={{
                        rows: {
                            style: {
                                fontSize: '16px',
                                fontWeight: '400',
                                lineHeight: '19px',
                                border: '0',
                                borderBottom: '1px solid #ABB3D1 !important',
                                minHeight: '51px!important'
                            }
                        },
                        cells: {
                            style: {
                                borderLeft: "1px solid #ABB3D1",
                                ':first-of-type': {
                                    border: '0 !important',
                                }
                            },
                        },
                    }}
                />
            </div>
        return (
            <div className='organic-table'>
                <div className='fertilizer-label'>Органические удобрения</div>
                {contents}
                <div className="add-btn-container">
                    <button className="btn add-btn" onClick={() => this.setState({isModalShow: true, isAdd: true})}><img
                        src={add} alt='add'/> Добавить
                    </button>
                </div>
                {this.AddModal(this.state.isModalShow, this.state.isAdd, this.state.rowId, this.state.afterChange)}
            </div>
        );
    }

    async populateFertilizersData() {
        const token = this.props.token;
        const organic_fertilizers = this.props.organic_fertilizers
        const organic_pattern = this.props.organic_pattern
        const fertilizers = organic_fertilizers
        const patterns = organic_pattern
        const patterns_list = patterns.map((el) => ({value: el.id, label: el.name}))
        const columns = [
            {
                cell: (row) =>
                    <button onClick={() => this.setState({isModalShow: true, isAdd: false, rowId: row.id})
                    } className="btn edit-row-btn"><img src={edit} alt='edit'/></button>,
                button: true,
                width: "0"
            }, {
                selector: row => row.name,
                sortable: true,
                width: "27%",
                wrap: true
            }, {
                selector: row => row.consuming1.n,
                width: "11%",
                center: true,
                compact: true,
            }, {
                selector: row => row.consuming1.p2O5,
                width: "11%",
                center: true,
                compact: true,
            }, {
                selector: row => row.consuming1.k2O,
                width: "11%",
                center: true,
                compact: true,
            }, {
                selector: row => row.consuming2.n,
                width: "11%",
                center: true,
                compact: true,
            }, {
                selector: row => row.consuming2.p2O5,
                width: "11%",
                center: true,
                compact: true,
            }, {
                selector: row => row.consuming2.k2O,
                width: "11%",
                center: true,
                compact: true,
            }, {
                selector: row => row.price,
                sortable: true,
                width: "7%",
                center: true,
                compact: true,
            }, {
                cell: (row) =>
                    <button onClick={() => this.handleClickDelete(row.id)} className="btn delete-row-btn">
                        <img src={del} alt='del'/></button>,
                button: true,
                width: "0"
            }]

        this.setState({
                fertilizers: fertilizers,
                columns: columns,
                patterns: patterns,
                patterns_list: patterns_list,
                selectedPattern: patterns_list[0].value,
            }
        );
    }

}
